var map = {
	"./Corniza-laminada.jpg": 6295,
	"./Rectangle-23-1.jpg": 5444,
	"./Rectangle-24-1.jpg": 8319,
	"./Rectangle-25-1.jpg": 9422,
	"./Rectangle-26-1.jpg": 4193,
	"./Rectangle-28.jpg": 1641,
	"./TABLILLA-IMPRESA-2.png": 9025,
	"./TABLILLA-LAMINADA-3.png": 2332
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 768;